import Page from './termos-de-uso'
export default Page
